import { render, staticRenderFns } from "./IconArrowEast.vue?vue&type=template&id=b9b84496"
import script from "./IconArrowEast.vue?vue&type=script&lang=js"
export * from "./IconArrowEast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports